import { BlockComponentFactory } from '../BlockFactory'
import type { TabsBlockProps } from './block-props.types'
import { useBlockChildren } from '../../hooks/useBlockChildren'
import { TabsBlock } from './TabsBlock'

const TabChildren: React.FC<{ childBlockConfigIds?: string[] }> = ({ childBlockConfigIds }) => {
    const tabChildren = useBlockChildren(childBlockConfigIds)
    return tabChildren && tabChildren.length > 0 ? tabChildren : null
}

export const TabsBlockRuntimeComponent = BlockComponentFactory.createBlockComponent<TabsBlockProps>(
    props => {
        const { items = [], ...restProps } = props

        const children = items.map(item => (
            <TabChildren key={item.id} childBlockConfigIds={item.childBlockConfigIds} />
        ))

        return <TabsBlock {...restProps} items={items} children={children} />
    }
)
